import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, LinearProgress } from "@mui/material";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";

import {
  getSettingState,
  setLoadNavigation,
} from "../../../redux/features/settingSlice";
import PlayListLoading from "./PlayListLoading/index";
import PlayList from "./PlayList";
import {
  getPlayerState,
  setPlayList,
} from "../../../redux/features/playerSlice";
import CustomModal from "../CustomModal";

const PlayListModal = () => {
  const { customModal } = useSelector(getSettingState);
  const { playList } = useSelector(getPlayerState);
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const dispatch = useDispatch();

  const { ref: refDown, inView: vDown } = useInView({
    threshold: 0,
  });

  const conditionalReq = () => {
    let mode = null;

    if (urlParams[3] === "opinions") {
      mode = `/content/topics/${urlParams[4]}/`;
    } else {
      mode = `/content/converses/${urlParams[4]}/`;
    }

    return mode;
  };

  const {
    data: topic,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;
      if (!customModal) return null;
      return `${process.env.REACT_APP_API + conditionalReq()}?page=${
        pageIndex + 1
      }`;
    },
    {
      revalidateFirstPage: true,
    }
  );

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    vDown && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vDown]);

  const moreInfinite = () => {
    if (topic) {
      const moreTopicCart = size + 1 <= topic[0]?.total_pages;
      if (moreTopicCart) {
        setSize(size + 1);
        dispatch(setLoadNavigation(true));
      } else {
        // setSize(topic[0].total_pages);
      }
    }
  };

  useEffect(() => {
    if (topic) {
      let topicList = [];
      // eslint-disable-next-line array-callback-return
      topic.map((e) => {
        topicList.push(...e.results);
      });
      dispatch(setPlayList(topicList));
    }
  }, [dispatch, topic]);

  return (
    <Box sx={{ height: "auto" }}>
      <CustomModal
        count={playList?.length}
        subject={
          urlParams[3] === "opinions"
            ? playList[0]?.opinion?.title
            : playList[0]?.conversation?.title
        }
      >
        {isLoading || !topic
          ? Array(10)
              .fill("")
              .map((e, i) => {
                return <PlayListLoading key={i} />;
              })
          : playList.map((row, i) => {
              return <PlayList key={row.pk} rowData={row} />;
            })}
        {!isLoading && topic && (
          <Box
            ref={refDown}
            sx={{ display: "flex", justifyContent: "center" }}
          ></Box>
        )}

        {!isLoading && isValidating && (
          <Box
            sx={{
              width: "100%",
              position: "absolute",
              bottom: 0,
              zIndex: 10,
              left: 0,
              right: 0,
            }}
          >
            <LinearProgress color='primary' />
          </Box>
        )}
      </CustomModal>
    </Box>
  );
};
export default PlayListModal;
